
function panoramaHotSpot(data, no, north) {
	this.properties = data;
	this.helper = null;
	this.helperLeft = null;
	this.helperRight = null;
	this.tag = 'default';
	this.clicks = 0;
	this.morphHelperState = false;
	this.morphHelperPosition = 0;
	this.plate = null;
	this.lastHelperY = null;
	this.preventShowingInfo = false;
	this.updatePosition = true;
	this.canProceed = true;
	this.display = data.display;
	this.valign = true;
	this.no = no;
	this.shown = 0;
	this.north = north;
	this.hovericon = "";
	this.icon = "";
	this.hovering = false;
	this.hoveringdt = 0;
	this.visible = false;
	this.closestIndicator = true;

	if (this.properties.action == 'quest') {
		this.preventShowingInfo = true;
		//this.closestIndicator = false;
		this.canProceed = false;
		this.proceedEvent = function() {
			QuestManager.placeQuest(this.properties.quest, this);
		};
	}

	if (this.properties.angle == undefined) this.properties.angle = 0;

	if (this.properties.transition == undefined) {
		this.properties.transition = {"outzoom": 5, "inzoom": 5}; // 1
	}

	data.fullName = data.place.place_name;
	if (data.fullName == "" && data.place.place_type == "panorama") data.fullName = "Panorama " + data.ident;
	if (data.fullName == "" && data.place.place_type == "photo") data.fullName = "Zdjęcie " + data.ident;

	if (data.ident.substr(0,4) == "http") {
		data.fullName = data.ident;
		if (data.ident.length > 35) data.fullName = data.ident.substr(0,35) + " ...";
	}

	this.fullName = data.fullName;

	this.properties.x = parseFloat(this.properties.x);
	this.properties.y = parseFloat(this.properties.y);

	if (player.cms) {
		if (isNaN(this.properties.x)) this.properties.x = 0;
		if (isNaN(this.properties.y)) this.properties.y = 0;
	}

	this.thumbnail = data.place.thumb;

	if (player.offline) {
		if (this.thumbnail == "/html5/assets/eee.png?")
			this.thumbnail = "assets/eee.png";
		else
			this.thumbnail = "data/thumb_" + data.ident + ".jpg";
	}

	this.hasPreview = ((data.place.place_type != "autopilot" && data.place.place_type != "video") ? true : false);


	switch(this.display) {
		case "preview":
			this.updateDisplay("preview", data);
		break;

		default:
			this.updateDisplay("icon", data);
	}
	
	//Log.debug(data.spot);
//	if (data.place.place_name == "") 
/*
		var spotFile = "";
		var skip = false;
		var style = "";
		var cls = "";
		var dim = [50,50];
		var hasPreview = (data.place.place_type != "autopilot" ? true : false);

		if (data.spot == "1") spotFile = "1";
		if (data.spot == "2") spotFile = "2";
		if (data.spot == "3") spotFile = "3";
		if (data.spot == "4") spotFile = "4";
		if (data.spot == "5") spotFile = "5";
		if (data.spot == "6") spotFile = "6";
		if (data.spot == "7") spotFile = "7";
		if (data.spot == "10") spotFile = "10";
		if (data.spot == "11") spotFile = "11";
		if (data.spot == "14") spotFile = "14";
		if (data.spot == "15") spotFile = "15";
		if (data.spot == "16") spotFile = "16";
		if (data.spot == "17") spotFile = "17";
		if (data.spot == "18") spotFile = "18";

		this.spotType = spotFile;

		if (data.mapicon != undefined &&  data.mapicon != "" && data.nomapicon != "true") {
			skip = true;
			spotFile = "../../gicons/" + data.mapicon;
			cls = " icon";
			dim[0] = 32; dim[1] = 37;
			style = "position:absolute;left:-16px;top:-32px;z-index:99";
		}
		
		this.node = $("<div class='hotspot" + cls + "' id='" + no + "'></div>");
		if (spotFile == "") {
			spotFile = "hotspot2_top.png";
		//	this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2_bg.png' width='50' height='50'><img src='/html5/assets/hotspot2_top.png' width='50' height='50' class='fulllooprotation'><div class='spotdesc'><a href='javascript:void(null);' ontouchend='player.go(" + data.ident + "," + data.angle + ")' class='button'>Przejdź</a></div></div>"); //HotSpotManager.more(\"" + no + "\")
		} else if (skip == false) {
//			spotFile = "hotspot2_top.png";
			spotFile = "spots/" + spotFile + ".png";
		//	this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2_bg.png' width='50' height='50'><img src='/html5/assets/spots/" + spotFile + ".png' width='50' height='50'><img src='/html5/assets/hotspot2_top.png' width='50' height='50' class='fulllooprotation'><div class='spotdesc'><a href='javascript:void(null);' ontouchend='player.go('" + data.ident + "'," + data.angle + ")' class='button'>Przejdź</a></div></div>"); //HotSpotManager.more(\"" + no + "\")
		}

		//console.log(data);

		data.fullName = data.place.place_name;
		if (data.fullName == "" && data.place.place_type == "panorama") data.fullName = "Panorama " + data.ident;
		if (data.fullName == "" && data.place.place_type == "photo") data.fullName = "Zdjęcie " + data.ident;

		var thumbnail = data.place.thumb;
		if (player.offline) thumbnail = "data/thumb_" + data.ident + ".jpg";

		if (data.ident.substr(0,4) == "http") {
			hasPreview = false;
			data.fullName = data.ident;
			if (data.ident.length > 35) data.fullName = data.ident.substr(0,35) + " ...";
		}

		data.html = "";

		if (data.place.place_type == "catalogue3D") {
			data.fullName = "Gallery";
			hasPreview = false;
			data.html = "<div style='text-align:center;padding: 15px;color: #000000'><i class='fa fa-camera' style='font-size:40px;opacity:0.5'></i></div>";
		}

		this.node.html(TPL.render("hotspot-template", {"no": no, "hasPreview" : hasPreview, "spotfile": spotFile, "ident": data.ident, "angle": data.angle, "click" : "on" + Events.pointer.down, "data": data, "thumbnail": thumbnail, "ico_width": dim[0], "ico_height": dim[1], "style": style}));
*/
//	else
//		this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2.png' width='50' height='50' ontouchend='HotSpotManager.more(\"" + no + "\")'><div class='spotdesc'>" + data.place.place_name + "<br><br><a href='javascript:void(null);' ontouchend='player.go(" + data.ident + "," + data.angle + ")' class='button'>Przejdź</a></div></div>");
	
//	$("#player").append(this.node);
	//console.log(this.properties.place.place_name + ": " + this.properties.x + " ; " + this.properties.y);

	this.properties.x += (parseFloat(north) - 95);
	//console.log(north + " - " + this.properties.x);

	var mtx = new Matrix3D();
	mtx = mtx.rotateY((this.properties.x) * Math.PI / 180);
//	mtx = mtx.rotateY((this.properties.x - 95) * Math.PI / 180);
//	mtx = mtx.rotateY((this.properties.x - 90) * Math.PI / 180);
	var pt = new Vector3D(0,this.properties.y,1500);
	pt = pt.transformByMatrix(mtx);

	//Console.place("db" + no,pt.x * 0.05 + 500,pt.z * 0.05 + 90,"<a href='' title='" + data.place.place_name + " (" + pt.x + ", " + pt.z + ")'>X</a>");

//	var px = Math.sin(this.properties.x * (Math.PI / 180)) * 1500;
	
	this.vec3D = new Vector3D(pt.x, pt.y, pt.z);

	AppEvent.trigger(player, "HOTSPOT.CREATED", this);
}

panoramaHotSpot.prototype = {

	findIconFile: function(icon) {
		var spotFile = "";
		var type = "base";

		if (icon == "0") spotFile = "0";
		if (icon == "1") spotFile = "1";
		if (icon == "2") spotFile = "2";
		if (icon == "3") spotFile = "3";
		if (icon == "4") spotFile = "4";
		if (icon == "5") spotFile = "5";
		if (icon == "6") spotFile = "6";
		if (icon == "7") spotFile = "7";
		if (icon == "10") spotFile = "10";
		if (icon == "11") spotFile = "11";
		if (icon == "14") spotFile = "14";
		if (icon == "15") spotFile = "15";
		if (icon == "16") spotFile = "16";
		if (icon == "17") spotFile = "17";
		if (icon == "18") spotFile = "18";

		if (spotFile == "0" || icon == "" || icon == "none") {
			
			spotFile = "/html5/assets/hotspot2_top.png";

		} else if (spotFile != "") spotFile = "/html5/assets/spots/" + spotFile + ".png";

		if (icon != "" && spotFile == "") {
			spotFile = icon;
			type = "custom";
		}

		if (player.offline) {
			if (type == "custom") {
				spotFile = "assets/spots" + spotFile;
			} else {
				spotFile = spotFile.replace("/html5/", "");
			}
		}

		if (this.properties.action == 'quest') {
			spotFile = "assets/spots/quest.png";
		}

		return {"file": spotFile, "type": type};
	},

	updateIcon: function(icon, hover) {
		ff = this.findIconFile(icon);
		this.node.find(".ico").attr("src", ff.file);

		this.icon = ff.file;
		this.hovericon = hover;

		this.properties.spot = icon;
		this.properties.hover = hover;

		if (ff.type == "custom") {
			this.node.find(".bg").hide();
		} else {
			this.node.find(".bg").show();
		}
		//this.node.html(TPL.render("hotspot-template", {"no": this.no, "hasPreview" : this.hasPreview, "spotfile": spotFile, "ident": this.properties.ident, "angle": this.properties.angle, "click" : "on" + Events.pointer.down, "data": this.properties, "thumbnail": this.thumbnail, "ico_width": this.dim[0], "ico_height": this.dim[1], "style": this.style}));
	},

	speakTitle: function() {

		if (this.speakHoverEvent != undefined) this.speakHoverEvent();

		if (this.properties.place.speech_title != undefined && this.properties.place.speech_title != null && this.properties.place.speech_title != "") {
			//if (this.lastspeak == undefined || (Date.now() - this.lastspeak) > 1500) SpeechManager.speakTip(this.properties.place.speech_title, "TOPMENU");
			//this.lastspeak = Date.now();
			//SpeechManager.speakTip(this.properties.place.speech_title, "TOPMENU");
			if (HotSpotManager.lastspeak != this.properties.place.speech_title && this.visible) {
				SpeechManager.speakTip({"sound": this.properties.place.speech_title, "pre": this.properties.presound}, "TOPMENU", 2);
				HotSpotManager.lastspeak = this.properties.place.speech_title;
			}
		}
		HotSpotManager.lastspeaktitle = this.properties.place.speech_title;
	},

	setIconDisplay: function(data) {
		var spotFile = "";
		var skip = false;
		var style = "";
		var cls = "";
		var dim = [50,50];

		var hasPreview = ((data.place.place_type != "autopilot" && data.place.place_type != "video") ? true : false);

		if (data.with_lift != undefined) this.properties.with_lift = data.with_lift;

		var ff = this.findIconFile(data.spot);
		spotFile = ff.file;

		this.spotType = data.spot; //spotFile;

		if (data.mapicon != undefined &&  data.mapicon != "" && data.nomapicon != "true" && data.nomapicon != true) {
			skip = true;
			if (player.offline) spotFile = "assets/gicons/" + data.mapicon;
			else spotFile = "../../gicons/" + data.mapicon;
			cls = " icon";
			dim[0] = 32; dim[1] = 37;
			style = "position:absolute;left:-16px;top:-32px;z-index:99";
		}
		
		this.node = $("<div class='hotspot" + cls + "' id='" + this.no + "'></div>");

		if (this.properties.action == 'quest') {
			if (this.properties.quest_visibility == 'hide' && player.cms != '1') this.node.css('opacity', 0);
		}

		if (spotFile == "") {			
			spotFile = "/html5/assets/hotspot2_top.png";
		//	this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2_bg.png' width='50' height='50'><img src='/html5/assets/hotspot2_top.png' width='50' height='50' class='fulllooprotation'><div class='spotdesc'><a href='javascript:void(null);' ontouchend='player.go(" + data.ident + "," + data.angle + ")' class='button'>Przejdź</a></div></div>"); //HotSpotManager.more(\"" + no + "\")
		} else if (skip == false) {
//			spotFile = "hotspot2_top.png";

//////			spotFile = "spots/" + spotFile + ".png";

		//	this.node = $("<div class='hotspot' id='" + no + "'><img src='/html5/assets/hotspot2_bg.png' width='50' height='50'><img src='/html5/assets/spots/" + spotFile + ".png' width='50' height='50'><img src='/html5/assets/hotspot2_top.png' width='50' height='50' class='fulllooprotation'><div class='spotdesc'><a href='javascript:void(null);' ontouchend='player.go('" + data.ident + "'," + data.angle + ")' class='button'>Przejdź</a></div></div>"); //HotSpotManager.more(\"" + no + "\")
		}

		//console.log(data);

		data.fullName = data.place.place_name;
		if (data.fullName == "" && data.place.place_type == "panorama") data.fullName = "Panorama " + data.ident;
		if (data.fullName == "" && data.place.place_type == "photo") data.fullName = "Zdjęcie " + data.ident;

		var thumbnail = data.place.thumb;

		if (player.offline) {
			if (thumbnail == "/html5/assets/eee.png?")
				thumbnail = "assets/eee.png";
			else
				thumbnail = "data/thumb_" + data.ident + ".jpg";
		}

		if (data.ident.substr(0,4) == "http") {
			hasPreview = false;
			data.fullName = data.ident;
			if (data.ident.length > 35) data.fullName = data.ident.substr(0,35) + " ...";
		}

		data.html = "";

		if (data.place.place_type == "catalogue3D") {
			data.fullName = "Gallery";
			hasPreview = false;
			data.html = "<div style='text-align:center;padding: 15px;color: #000000'><i class='fa fa-camera' style='font-size:40px;opacity:0.5'></i></div>";
		}


		var lifth;
		var with_lift;

		if (data.with_lift == "1" || data.with_lift == "true") with_lift = 1; else with_lift = 0;

		if (data.lifth != undefined) lifth = parseInt(data.lifth);
		else lifth = 80;

		var offsety;

		if (dim[1] <= 37)
			offsety = (lifth + 5) * -1;
		else
			offsety = (lifth + 18) * -1;

		this.node.html(TPL.render("hotspot-template", {"no": this.no, "hasPreview" : hasPreview, "spotfile": spotFile, "ident": data.ident, "angle": data.angle, "click" : "on" + Events.pointer.down, "data": data, "thumbnail": thumbnail, "ico_width": dim[0], "ico_height": dim[1], "style": style, "offsety": offsety, "lifth": lifth, "with_lift": with_lift}));


		if (this.properties.quest_visibility == 'sparks') {
			this.node = $("<div class='hotspot' id='" + this.no + "'><dotlottie-player  key=\"dt2\" src=\"/html5/assets/animations/sparks.json\" background=\"transparent\" speed=\"1\" style=\"width: 90px; height: 90px; transform: translate(-50%, -50%);\" loop autoplay></dotlottie-player></div>");
			if (player.cms == '1') {
				this.node.append('<div style="position:absolute;left:0px;top:0px;width:100%;height:100%;transform:translateX(-50%) translateY(-50%);border:2px solid #ffffff"></div>');
			}
		};

		if (this.properties.scale != undefined) {
			this.node.find('.marker').css('transform', 'scale(' + this.properties.scale + ')');
		}

		if (ff.type == "custom") {
			this.node.find(".bg").hide();
		} else {
			this.node.find(".bg").show();
		}

		this.icon = spotFile;
		this.hovericon = data.hover;

		if (player.offline && this.hovericon != undefined) {
			this.hovericon = this.hovericon.replace("/graphics", "assets/spots/graphics");
		}

		var self = this;

		if (this.fullName != undefined && this.properties.action != 'quest')
			this.node.attr("title", TPL.lng("tips.clicktogo","Kliknij aby przejść do: ") + this.fullName.replace(/(<([^>]+)>)/gi, ""));

		//this.node.attr("title", "Kliknij aby przejść do: " + this.fullName);

		//this.node.on(Events.pointer.up, function() { self.target();});
		this.node.on(Events.pointer.up, function() { self.proceed();});
		this.node.on("mouseover", function() { 
			//if (self.preventShowingInfo == false) {
				if (self.properties.action != 'rt') HotSpotManager.more(self.no); 
				window.setStatus("ID: " + data.ident); 
				if (self.hovericon != undefined && self.hovericon != "") {
					self.node.find(".ico").attr("src", self.hovericon);
				}

				// turn off speaking title on hover
				//if (!self.hovering && (Date.now() - self.hoveringdt) > 1000) self.speakTitle();

				self.hoveringdt = Date.now();
				self.hovering = true;
				//if (self.sidetext != undefined && this.properties.text_placement == 'over') self.sidetext.hide();
			//}
		});
		this.node.on("mouseleave", function() {
			self.hovering = false;
			self.noMore();
			window.setStatus("");
			if (self.hovericon != undefined && self.hovericon != "") {
				self.node.find(".ico").attr("src", self.icon);
			}
			//if (self.sidetext != undefined && this.properties.text_placement == 'over') self.sidetext.show();
		});

		this.node.find(".close").on(Events.pointer.up, function(e) {self.noMore(); e.stopPropagation();});		

		this.attachDisplay();

		if (player.cms) {
			this.node.find(".marker").addClass("hcms");
		}
	},

	setPreviewDisplay: function(params) {
		var title = "";

		if (params.shape != undefined) this.properties.shape = params.shape;

		if (params.with_title != undefined) this.properties.with_title = params.with_title;
		if (params.with_lift != undefined) this.properties.with_lift = params.with_lift;


		if (params.shape == 'circle') {
			if (this.properties.with_title) {
				title = "<div class='circle-title'>" + this.fullName + "</div>";
			}
			this.node = $("<div class='hotspot' id='" + this.no + "'>" + title + "<div class='circle-preview-spot' style='background-image:url(\"" + this.thumbnail + "\")'></div><div class='circle-marker'></div></div>");
		} else {
			if (this.properties.with_title) {
				title = "<div class='rect-title'>" + this.fullName + "</div>";
			}
			this.node = $("<div class='hotspot' id='" + this.no + "'>" + title + "<div class='rect-preview-spot' style='background-image:url(\"" + this.thumbnail + "\")'></div><div class='rect-marker'></div></div>");
		}

		var self = this;
		if (!player.cms) {
			this.node.on(Events.pointer.up, function() { self.proceed();});
		}

		this.node.on("mouseover", function() { window.setStatus("ID: " + self.properties.ident); });

		this.attachDisplay();
	},

	setDirectionDisplay: function(params) {
	},

	setAction: function(act, id, ang) {
		this.properties.action = act;
		this.properties.ident = id;
		this.properties.angle = ang;
	},

	setPosition: function(x, y) {
		this.properties.x = parseFloat(x) + (parseFloat(this.north) - 95);
		this.properties.y = parseFloat(y);
	},

	attachDisplay: function() {
		$("#hotspots").append(this.node);

		this.node3D = new css3DNode("#" + this.no);

		if (player.cms) {
			if (this.editor == undefined) {
				this.editor = new HotSpotEdit(this);
				//this.no = no;
				//this.hasPreview = hasPreview;
				//this.thumbnail = thumbnail;

				//this.dim = dim;
				//this.style = style;
				this.editor.addUI();
			} else {
				var self = this;
			    this.node.on("click", function(evt) {var pe = Events.getPointerEvent(evt); self.editor.click(pe);});
			    //this.node.append(this.editor.mover);
			    this.editor.hs = this;
			    this.editor.hs.node = this.node;
			    
				this.editor.addUI();
			}
		}
	},

	updateSound: function(s) {
		this.properties.sound = s;
	},

	updateSidetext: function(enable, placement, alignment, force) {
		var org_enable = enable;
		if (enable == '' || enable == undefined) {
			if (window.PROJECT.settings['hotspot/show_text'] == '1') {
				enable = 1;
				if (window.PROJECT.settings['hotspot/text_pos'] && window.PROJECT.settings['hotspot/text_pos']!= 'brak') placement = window.PROJECT.settings['hotspot/text_pos'] ? window.PROJECT.settings['hotspot/text_pos'] : false;
				if (window.PROJECT.settings['hotspot/text_align'] && window.PROJECT.settings['hotspot/text_align']!= 'brak') alignment = window.PROJECT.settings['hotspot/text_align'] ? window.PROJECT.settings['hotspot/text_align'] : false;
			} else {
				enable = false;
			}
		}
		if (enable == '-1' || enable == 'false') enable = false;

		this.properties.with_text = org_enable;
		this.properties.text_placement = placement;
		this.properties.text_alignment = alignment;

		if ((this.sidetext == undefined || force) && enable) {
			this.sidetext = $("<div class='sidetext'>" + this.fullName + "</div>");
			this.node.append(this.sidetext);
		} else if (!enable && this.sidetext != undefined) {
			this.sidetext.remove();
			this.sidetext = undefined;
		}

		if (enable) {
			if (placement == 'left') {
				this.sidetext.addClass("left");
				this.sidetext.removeClass("right");
				this.sidetext.removeClass("under");
				this.sidetext.removeClass("over");
			} else if (placement == 'under') {
				this.sidetext.addClass("under");
				this.sidetext.removeClass("left");
				this.sidetext.removeClass("right");
				this.sidetext.removeClass("over");
			} else if (placement == 'over') {
				this.sidetext.addClass("over");
				this.sidetext.removeClass("under");
				this.sidetext.removeClass("left");
				this.sidetext.removeClass("right");
			} else {
				this.sidetext.addClass("right");
				this.sidetext.removeClass("left");
				this.sidetext.removeClass("under");
				this.sidetext.removeClass("over");
			}

			if (alignment != undefined) {
				this.sidetext.css("text-align", alignment);
			}

			var lifth;
			if (this.properties.with_lift == "1") {
				if (this.properties.lifth != undefined) lifth = parseInt(this.properties.lifth);
				else lifth = 80;
				this.sidetext.css("top", (-lifth - 32) + "px");
			} else {
				this.sidetext.css("top", "-8px");
			}
		}
	},

	updateDisplay: function(type, params) {
		if (this.node != undefined) {
			this.node.remove();
		}
		
		this.display = type;

		if (type == 'icon') this.setIconDisplay(params);
		if (type == 'preview') this.setPreviewDisplay(params);
		if (type == 'direction') this.setDirectionDisplay(params);

		if (window.PROJECT.settings['hotspot/show_text'] == '1' && this.properties.with_text != '-1' && this.properties.with_text != '1') {
			this.properties.with_text = '1';
			if (window.PROJECT.settings['hotspot/text_pos'] && window.PROJECT.settings['hotspot/text_pos']!= 'brak') this.properties.text_placement = window.PROJECT.settings['hotspot/text_pos'] ? window.PROJECT.settings['hotspot/text_pos'] : false;
			if (window.PROJECT.settings['hotspot/text_align'] && window.PROJECT.settings['hotspot/text_align']!= 'brak') this.properties.text_alignment = window.PROJECT.settings['hotspot/text_align'] ? window.PROJECT.settings['hotspot/text_align'] : false;
		}

		this.updateSidetext(
			this.properties.with_text == "true" || this.properties.with_text == "1" || this.properties.with_text === true || this.properties.with_text === 1 ? true : this.properties.with_text,
			this.properties.text_placement,
			this.properties.text_alignment,
			true);
	},

	remove: function() {
		$("#hotspots").remove(this.node);
	},

	more: function() {

		if (this.preventShowingInfo == false) {
			if (this.properties.place.place_type != "autopilot") {
				this.node.find(".spotdesc").show();
			}

			//var all = $("#hotspots .hotspot");
			//this.node.insertBefore(all.eq(0));
			$("#hotspots").append(this.node);
		}
	},
	
	noMore: function() {
		this.node.find(".spotdesc").hide();
	},

	proceed: function(force) {
		var self = this;

		if (this.proceedEvent != undefined) this.proceedEvent(force);
		if (!this.canProceed) return;

		//console.log("Proceeding");

		HotSpotManager.setTransition(this.properties.transition);

		//console.log("PROCEEDING");
		//console.log(this.properties.sound);

		//player.currentView.turnToAnd(this.lookAtCoords().x, this.lookAtCoords().y, 60, function() {

		AppEvent.trigger(player, "HOTSPOT.STARTLOOKING", self);

		if (this.preventShowingInfo) {
			//if (!player.cms) {
				player.currentView.turnToAnd(this.lookAtCoords().x, this.lookAtCoords().y, 60, function() {
					AppEvent.trigger(player, "HOTSPOT.LOOKAT", self);
				});
			//}

			return;
		}

		var ry = 0;
		var rx = 0;
		// this is default centering based on hotspot icon
		if (!this.valign) ry = this.lookAtCoords().y;

		// this is forced hotspot centering based on hotspot settings
		if (this.properties.centermode == 'horizon') ry = 0;
		if (this.properties.centermode == 'exact') ry = this.lookAtCoords().y;
		rx = this.lookAtCoords().x;

		if (this.properties.action != undefined && this.properties.action == "rt" && this.properties.angle != "" && this.properties.angle != "0") {
			var drs = this.properties.angle.toString().split(",");
//			rx = parseFloat(drs[0]) - parseFloat(player.current.properties.north) + 95;// + (parseFloat(this.north) - 95);			
//			rx = parseFloat(drs[0]) + (parseFloat(this.north) - 95);			
//			rx = parseFloat(drs[0]) - parseFloat(player.current.properties.north) + 95;// + (parseFloat(this.north) - 95);			

			rx = parseFloat(drs[0]) + 180 + (parseFloat(this.north) - 95);			
			if (drs.length > 1) ry = - parseFloat(drs[1]);
			//ry = -1 * Math.tan(parseFloat(drs[1]) * (Math.PI/180)) * 1500;

			//res.x = this.properties.x + 180;
			//res.y = (Math.atan(this.properties.y / 1500) * 180 / Math.PI);

		}

		if (!player.cms || force == 1) {

			if (this.properties.sound != undefined && this.properties.sound.effect != "") {
				if (this.audioEffect != undefined) {
					this.audioEffect.pause();
					delete this.audioEffect;
				}
				this.audioEffect = new Audio("/storage/sounds/effects" + this.properties.sound.effect);
				this.audioEffect.play();

				var self = this;
				this.paudio_event = this.audioEffect.addEventListener('timeupdate', function(event) {
	  				if (self.properties.sound.duration != undefined && self.properties.sound.duration > 0) {
	  					if (self.audioEffect.currentTime >= self.properties.sound.duration) {
	  						self.audioEffect.pause();
	  						self.audioEffect.currentTime = 0;
	  					}
	  					/*
	  					 else if (self.audioEffect.currentTime >= self.properties.sound.duration - 0.2) {
	  						self.audioEffect.volume -= 0.1;
	  					}
	  					*/
	  				}
				});

			}

			player.currentView.turnToAnd(rx, ry, {speed:60, rangeX:10, rangeY:20}, function() {
				AppEvent.trigger(player, "HOTSPOT.LOOKAT", self);				
				var a = self.properties.angle;
				
				if (self.properties.turn_to != undefined) {
					var tt = self.getTurn(self.properties.turn_to, self.properties.angle);
					a = [self.properties.angle, tt];
				}

				if (self.properties.action == undefined || self.properties.action == "go") player.go(self.properties.ident, a, true);
			});
		} else {
			this.clicks ++;
			if (this.clicks > 1) {
				player.currentView.turnToAnd(rx, ry, {speed:60, rangeX:10, rangeY:20}, function() {
					AppEvent.trigger(player, "HOTSPOT.LOOKAT", self);					
					var a = self.properties.angle;

					if ((self.properties.action == undefined || self.properties.action == "go") && self.properties.turn_to != undefined) {
						var tt = self.getTurn(self.properties.turn_to, self.properties.angle);
						a = [self.properties.angle, tt];
						player.go(self.properties.ident, a, true);
					}
				});
			}

			var self = this;
			
			if (this.resetclicktimer != undefined) clearTimeout(this.resetclicktimer);

			this.resetclicktimer = setTimeout(function() {
				self.clicks = 0;
				this.resetclicktimer = undefined;
			}, 1000);
		}
	},

	getTurn: function(t, a) {

		var dirs = a.split(",");
		var turn = [];
		if (!isNaN(t)) t = t.toString();
		
		if (t != undefined && t != "") {
			turn = t.split(",");
			turn[0] = parseInt(turn[0]) + parseInt(dirs[0]);
			if (turn.length > 1) {
				turn[1] = parseInt(turn[1]);
				if (dirs.length > 1) turn[1] += parseInt(dirs[1]);
			}
		}
		

		var res = turn[0];
		if (turn.length > 1) res += "," + turn[1];

		return res;
		
		//return t;
	},

	target: function() {
		var self = this;

		if (!this.canProceed) return;

		setTimeout(function() {
			if (self.clicks < 2) {
				HotSpotManager.more(self.no); 
				self.clicks = 0;
			}
		}, 300);

		this.clicks ++;
		if (this.clicks > 1) this.noMore();

		AppEvent.trigger(player, "HOTSPOT.STARTLOOKING", self);
		
		var dy = 0;

		//console.log(this.spotType);

		if (this.spotType != 1 && this.spotType != 3 && this.spotType != 7) {
			dy = this.lookAtCoords().y;
		} else {
			dy = player.currentView.renderer.ry;
		}

		if (!player.cms) {
			player.currentView.turnToAnd(this.lookAtCoords().x, dy, 60, function() {
				AppEvent.trigger(player, "HOTSPOT.LOOKAT", self);
				if (self.clicks > 1) player.go(self.properties.ident, self.properties.angle);
			});
		}
	},

	displayHelper: function(dir, res, mtx) {
		var result;

		if (this.helper != null) {

			result = Object.create(res);
			result2 = Object.create(res);

			result.transformByMatrix(mtx); //mtx
			
			var pt = result.projectTo2D();
			var margin = (HotSpotManager.playerHeight * 0.3);

			// plane equation normal
			var line = new Vector3D(1, 0, 0);
			var dist = line.dot(result);

			var fx = -pt.x * (HotSpotManager.playerWidth * 0.5) + HotSpotManager.playerWidth * 0.5;
			var fy = pt.y * (HotSpotManager.playerHeight * 0.5) + HotSpotManager.playerHeight * 0.5;

			var fy = (HotSpotManager.playerHeight * 0.5) + (this.properties.y * -0.7) + (player.currentView.getRY() * 10);

			//this.helper.find(".hleft").html(fy);
			//this.helper.find(".hright").html(fy);

			if (fy < margin) fy = margin;
			if (fy > HotSpotManager.playerHeight - margin) fy = HotSpotManager.playerHeight - margin;

			if (dir <= 0 && fx >= (this.helperWidth) && fx <= (HotSpotManager.playerWidth + (this.helperWidth * -1))) {
				this.morphHelper(false, fx + this.helperWidth * -0.5 - 30, fy - 30);
				return;
			}

			// transform only vertical position of spot
			
			result2.transformByMatrix(HotSpotManager.helperMatrix);
			var pt = result2.projectTo2D();
			
			var fy = pt.y * (HotSpotManager.playerHeight * 0.5) + HotSpotManager.playerHeight * 0.5; // + HotSpotManager.playerWidth * 0.04;

			var fy = (HotSpotManager.playerHeight * 0.5) + (this.properties.y * -0.7) + (player.currentView.getRY() * 10);

			if (fy < margin) fy = margin;
			if (fy > HotSpotManager.playerHeight - margin) fy = HotSpotManager.playerHeight - margin;

			//if (fy < 100) fy = 100;
			//if (fy > 500) fy = 500;

			var hspace;

			var l = 0;
			if(dist < 0) {
			//	this.helper.css("left", "10px");
				l = 10;
				if (this.helperLeft == null) this.helperLeft = this.helper.find(".hleft");
				this.helperLeft.show();

				if (this.helperRight == null)  this.helperRight = this.helper.find(".hright");
				this.helperRight.hide();

				hspace = {'d': 'l', 'y': fy};

			} else  {
			//	this.helper.css("left", (HotSpotManager.playerWidth - this.helperWidth - 40) + "px");
				l = (HotSpotManager.playerWidth - this.helperWidth - 40);
				if (this.helperLeft == null) this.helperLeft = this.helper.find(".hleft");
				this.helperLeft.hide();

				if (this.helperRight == null)  this.helperRight = this.helper.find(".hright");
				this.helperRight.show();

				hspace = {'d': 'r', 'y': fy};
			}
			
			fy = HotSpotManager.arrangeHelpers(hspace);

			if (this.lastHelperY == null) this.lastHelperY = fy;
			fy = this.lastHelperY + (fy - this.lastHelperY) * 0.05;

			//this.helper.css("top", fy + "px");

			if (player._width < 500 || player._height < 500) {
				this.helperLeft.hide();
				this.helperRight.hide();

				if (dir <= 0 && fx >= 0 && fx <= HotSpotManager.playerWidth) {
					this.morphHelper(false, fx + this.helperWidth * -0.5 - 30, fy - 30);
					return;
				}

				return;
			}


			//this.helper.show();
			this.morphHelper(true, l, fy);

			this.lastHelperY = fy;
		}

	},

	morphHelper: function(dest, x, y) {

		//this.helper.find(".hleft").html(x);
		//this.helper.find(".hright").html(x);

		//if (this.morphHelperState) this.helper.show();
		//else this.helper.hide();
		
		this.helper.show();

		if (!dest) {
			this.helper.css("z-index","99");
			if (this.plate == undefined) this.plate = this.node.find(".plate");
			this.plate.addClass("plated");
		} else {
			this.helper.css("z-index","");
			if (this.plate == undefined) this.plate = this.node.find(".plate");
			this.plate.removeClass("plated");
		}

		//this.morphHelperState = dest;
		if (this.morphHelperState != dest) {
			this.morphHelperPosition += (dest ? 2 : -2);
		}
		
		if (this.morphHelperPosition <= 0 || this.morphHelperPosition >= 100) {
			this.morphHelperState = dest;
			if (dest) {
				this.helper.css("visibility", "visible");
			} else {
				this.helper.css("visibility", "hidden");
				//this.node.css("transform", "translateZ(0)");
			}

		} else {
			this.morphHelperPosition += (dest ? 1 : -1);
			this.helper.css("visibility", "visible");
			this.helper.css("opacity", this.morphHelperPosition * 0.015);			
		}

		if (dest && x != undefined && y != undefined) {
			this.helper.css("transform","translate3d(" + x + "px, " + y + "px, 0)");
			this.morph_x = x;
			this.morph_y = y;
			this.morph_ox = x;
			this.morph_oy = y;
		} else if (!dest && x != undefined && y != undefined) {
			this.morph_x += (x - this.morph_x) * 0.2;
			this.morph_y += (y - this.morph_y) * 0.2;
			//var s = this.morphHelperPosition * 0.01;
			this.helper.css("transform","translate3d(" + this.morph_x + "px, " + this.morph_y + "px, 0)"); //" scale(" + s + "," + s + ")");
		}
	},

	process: function(mtx, dir) {
		
		var result = new Vector3D(0,0,0);
		var norm = new Vector3D(0,0,0);

		result.x = this.vec3D.x;
		result.y = this.vec3D.y;
		result.z = this.vec3D.z;
		
		norm.x = this.vec3D.x;
		norm.y = this.vec3D.y;
		norm.z = this.vec3D.z;
		norm.normalize();


		if (norm.dot(dir) > 0) {
			//console.log(norm.dot(dir));
			this.displayHelper(norm.dot(dir), result, mtx);
			//Console.place("db" + this.no,this.vec3D.x * 0.05 + 250,this.vec3D.z * 0.05 + 90,"<a href='' title='" + this.properties.place.place_name + " (" + this.vec3D.x + ", " + this.vec3D.z + ")'>.</a>");
		
			this.visible = false;	
			this.node.css("visibility", "hidden");
			/*
			if (this.shown) {
				this.node.css("visibility", "hidden");
				this.shown = false;
			}
			*/
			return;
		}

		if (this.helper != null) {
			this.displayHelper(norm.dot(dir), result, mtx);
		}

		this.node.css("visibility", "visible");

		/*
		if (!this.shown) {
			//this.node.show();
			this.node.css("visibility", "visible");
			this.shown = true;
		}
		*/
		
		result.transformByMatrix(mtx);
		
		var pt = result.projectTo2D();
		
		/*
		Console.put("px",20,30,result.x);
		Console.put("py",20,50,result.y);
		Console.put("pz",20,70,result.z);
		*/
		//fx = -pt.x * ($("#player").width() * 0.5) + $("#player").width() * 0.5;
		//fy = pt.y * ($("#player").height() * 0.5) + $("#player").height() * 0.5;
		
		fx = -pt.x * (HotSpotManager.playerWidth * 0.5) + HotSpotManager.playerWidth * 0.5;
		fy = pt.y * (HotSpotManager.playerHeight * 0.5) + HotSpotManager.playerHeight * 0.5;
		
		var lifth;
		if (this.properties.with_lift == "1") {
			if (this.properties.lifth != undefined) lifth = parseInt(this.properties.lifth);
			else lifth = 80;
		} else {
			lifth = 0;
		}

		if (fy < 175 + lifth) 
			this.node.find(".spotdesc").addClass("flip");
		else
			this.node.find(".spotdesc").removeClass("flip");
		//Console.place("db" + this.no, this.vec3D.x * 0.05 + 250, this.vec3D.z * 0.05 + 90, "<a href='' title='" + this.properties.place.place_name + " (" + this.vec3D.x + ", " + this.vec3D.z + ")'>X[" + pt.y.toFixed(2) + "]</a>");
		
		//var fy = this.properties.y + 400;
		//var fx = this.properties.x;
		
		//this.node.css("left",fx+"px");
		//this.node.css("top",fy+"px");
		
		if (this.updatePosition) {
			this.node3D.resetTransform();
			this.node3D.translate(fx, fy, 0);
			this.node3D.applyTransforms();
		}

		if (player.lastIdent == this.properties.ident && this.tag != 'indicator') {
			HotSpotManager.setLastVisited(this, fx, fy);
		}

		if (fx < 0 || fy < 0 || fx > HotSpotManager.playerWidth || fy > HotSpotManager.playerHeight) {
			this.visible = false;
		} else {
			this.visible = true;
		}

		return {"x": fx, "y": fy};
	},
	
	remove: function() {
		this.node.remove();
	},

	addHelper: function(l,r) {
		this.helper = $("<div class='hotspot_helper'><div class='hleft'></div><div class='hright'></div></div>");
		this.helper.find(".hleft").append(l);
		this.helper.find(".hright").append(r);
		this.helperWidth = 50;		
		$("#hotspots").append(this.helper);
	},

	removeHelper: function() {		
		if (this.helper != null) {
			this.helper.remove();
			this.helper = null;
			this.helperLeft = null;
			this.helperRight = null;
		}
	},

	lookAtCoords: function() {
		var res = {};

		res.x = this.properties.x + 180;
		res.y = (Math.atan(this.properties.y / 1500) * 180 / Math.PI);

		return res;
	},

	fadeIn: function() {
		var self = this;

//		console.log("fadein");

		setTimeout(function() {
			self.node.find(".marker").addClass("fin");
		}, (Math.random() * 500) + 40);
	},

	looted: function() {
		if (QuestManager.looted[this.properties.quest] === true) return true;
		return false;
	}
}